import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';
import { setFilters } from '../features/filters/filterSlice';

export const useUserFilters = (user) => {
  const [userFilters, setUserFilters] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchUserFilters = async () => {
      if (!user) {
        setUserFilters(null);
        dispatch(setFilters({
          tournamentNames: [],
          teamNames: [],
          gameTitles: []
        }));
        return;
      }

      try {
        const userFiltersRef = collection(db, 'userFilters');
        const q = query(userFiltersRef, where('userId', '==', user.uid));
        const userFiltersSnap = await getDocs(q);
        
        if (!userFiltersSnap.empty) {
          const filterData = userFiltersSnap.docs[0].data();
          setUserFilters(filterData);
          
          // Reduxストアにフィルターを設定
          dispatch(setFilters({
            tournamentNames: filterData.tournamentNames || [],
            teamNames: filterData.teamNames || [],
            gameTitles: filterData.gameTitles || []
          }));
        } else {
          setUserFilters(null);
          dispatch(setFilters({
            tournamentNames: [],
            teamNames: [],
            gameTitles: []
          }));
        }
      } catch (error) {
        console.error('フィルター設定の取得に失敗しました:', error);
        setUserFilters(null);
        dispatch(setFilters({
          tournamentNames: [],
          teamNames: [],
          gameTitles: []
        }));
      }
    };

    fetchUserFilters();
  }, [user, dispatch]);

  return userFilters;
};
